import React, { useState, useEffect, useRef, useMemo } from "react";
import "../../pages/Surveys/style.css";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Row, Col, Card, CardBody, Input, Badge, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Progress, Table } from "reactstrap";
import { AssetListApi, AssetCategoryListApi, createAssetApi, updateAssetApi, listOfficesApi, deleteAssetApi, uploadAssetsApi, issueAssetApi } from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { FaSearch, FaEdit, FaEye, FaPrint, FaPlus, FaTrash, FaFileUpload, FaHistory, FaUser, FaCalendarAlt, FaCheckCircle, FaTimesCircle, FaDesktop, FaUserPlus } from "react-icons/fa";

const AssetList = (props) => {
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [is_processing, setProcessing] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const fileInputRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [category_list, seCategory_list] = useState([]);
  const [office_list, setOfficeList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [quickFilterText, setQuickFilterText] = useState("");

  // Create/Edit Modal State
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    asset_name: "",
    category_id: "",
    serial_number: "",
    tag_number: "",
    procurement_reference: "",
    office_id: "",
    assigned_to: "",
    specifications: "",
    remarks: ""
  });

  // Delete Confirmation Modal State
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Batch Processing State
  const [batchModalOpen, setBatchModalOpen] = useState(false);
  const [batchProgress, setBatchProgress] = useState(0);
  const [batchLogs, setBatchLogs] = useState([]);
  const [isBatchProcessing, setIsBatchProcessing] = useState(false);

  // View Details Modal State
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewAsset, setViewAsset] = useState(null);

  // Issue Asset Modal State
  const [issueModalOpen, setIssueModalOpen] = useState(false);
  const [issuingAsset, setIssuingAsset] = useState(null);
  const [issueFormData, setIssueFormData] = useState({ assigned_to: "", issue_remarks: "" });

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
      floatingFilter: false,
    };
  }, []);

  useEffect(() => {
    fetch_category_list();
    fetch_office_list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch_category_list = () => {
    setProcessing(true);
    AssetCategoryListApi()
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          var response = res.data;
          if (response.status === SUCCESS_RESULT) {
            seCategory_list(response.data);
          } else {
            cogoToast.error(res.data.message || "Failed to load categories");
          }
        }
      })
      .catch((err) => {
        setProcessing(false);
      });
  };

  const fetch_office_list = () => {
    listOfficesApi()
      .then((res) => {
        if (res.status === 200) {
          var response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setOfficeList(response.data);
          } else {
          }
        }
      })
      .catch((err) => {
      });
  };

  const fetch_data = (_category_id) => {
    setProcessing(true);
    const catId = _category_id !== undefined ? _category_id : selectedCategory;
    setSelectedCategory(catId);

    if (!catId) return;

    const payload = {
      category_id: catId,
    };

    AssetListApi(payload)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          var response = res.data;
          if (response.status === SUCCESS_RESULT) {
            if (response.data && response.data.length > 0) {
              setRowData(response.data);
            } else {
              setRowData([]);
            }
          } else {
            cogoToast.error(res.data.message || "Failed to load assets");
            setRowData([]);
          }
        }
      })
      .catch((err) => {
        setProcessing(false);
        cogoToast.error("Something went wrong, please try again.");
      });
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (modalOpen) {
      resetForm();
    }
  };

  const toggleDeleteModal = () => {
    setDeleteModalOpen(!deleteModalOpen);
    if (deleteModalOpen) {
      setDeleteId(null);
    }
  };

  const resetForm = () => {
    setFormData({
      asset_name: "",
      category_id: selectedCategory || "",
      serial_number: "",
      tag_number: "",
      procurement_reference: "",
      office_id: "",
      assigned_to: "",
      specifications: "",
      remarks: ""
    });
    setIsEditing(false);
    setEditId(null);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEdit = (asset) => {
    setIsEditing(true);
    setEditId(asset.id);

    setFormData({
      asset_name: asset.asset_name || "",
      category_id: asset.category_id || "",
      serial_number: asset.serial_number || "",
      tag_number: asset.tag_number || "",
      procurement_reference: asset.procurement_reference || "",
      office_id: asset.office_id || "",
      assigned_to: asset.assigned_to || "",
      specifications: asset.specifications || "",
      remarks: asset.remarks || ""
    });
    setModalOpen(true);
  };

  const handleView = (asset) => {
    setViewAsset(asset);
    setViewModalOpen(true);
  };

  const handleIssueClick = (asset) => {
    setIssuingAsset(asset);
    setIssueFormData({
      assigned_to: asset.assigned_to || "",
      issue_remarks: ""
    });
    setIssueModalOpen(true);
  };

  const handleIssueInputChange = (e) => {
    const { name, value } = e.target;
    setIssueFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleIssueSubmit = () => {
    if (!issueFormData.assigned_to) {
      cogoToast.warn("Please enter an email address to assign execution.");
      return;
    }

    setProcessing(true);
    const payload = {
      asset_id: issuingAsset.id,
      assigned_to: issueFormData.assigned_to,
      issue_remarks: issueFormData.issue_remarks
    };

    issueAssetApi(payload)
      .then(res => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === 10001) {
            cogoToast.success(response.message || "Asset issued successfully");
            setIssueModalOpen(false);
            fetch_data();
          } else {
            cogoToast.error(response.message || "Failed to issue asset");
          }
        } else {
          cogoToast.error("Server error");
        }
      })
      .catch(err => {
        setProcessing(false);
        cogoToast.error("An unexpected error occurred");
      });
  };

  const handleDeleteClick = (asset) => {
    setDeleteId(asset.id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (!deleteId) return;

    setProcessing(true);
    const payload = { asset_id: deleteId };

    deleteAssetApi(payload)
      .then(res => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === 10001) {
            cogoToast.success(response.message || "Asset deleted successfully");
            toggleDeleteModal();
            fetch_data(); // Refresh
          } else {
            cogoToast.error(response.message || "Delete failed");
          }
        } else {
          cogoToast.error("Server error during deletion");
        }
      })
      .catch(err => {
        setProcessing(false);
        cogoToast.error("An unexpected error occurred");
      });
  };

  const handleSave = () => {
    if (!formData.asset_name || !formData.category_id) {
      cogoToast.warn("Please fill in required fields (Name, Category)");
      return;
    }

    setProcessing(true);
    const apiCall = isEditing ? updateAssetApi : createAssetApi;

    const payload = { ...formData };
    if (isEditing) {
      payload.asset_id = editId;
    }

    apiCall(payload)
      .then(res => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === 10001) {
            if (response.message === "The asset record is already registered. Thank you.") {
              cogoToast.warn(response.message);
            } else {
              cogoToast.success(response.message || "Saved successfully");
              toggleModal();
              fetch_data();
            }
          } else {
            cogoToast.error(response.message || "Operation failed");
          }
        } else {
          cogoToast.error("Server error");
        }
      })
      .catch(err => {
        setProcessing(false);
        cogoToast.error("An unexpected error occurred");
      });
  };

  // --- Batch Import Logic ---
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProcessing(true);
    const formData = new FormData();
    formData.append('file', file);

    uploadAssetsApi(formData)
      .then(res => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT || response.status === 10001) {
            cogoToast.success(response.message || "Assets imported successfully");
            fetch_data();
          } else {
            cogoToast.error(response.message || "Import failed");
          }
        } else {
          cogoToast.error("Server error during upload");
        }
        // Reset input
        e.target.value = null;
      })
      .catch(err => {
        setProcessing(false);
        cogoToast.error("An unexpected error occurred during upload");
        e.target.value = null;
      });
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.sizeColumnsToFit();
  };

  const onFilterTextChange = (e) => {
    setQuickFilterText(e.target.value);
    if (gridApi) {
      gridApi.setQuickFilter(e.target.value);
    }
  };

  const getSpecValue = (params, key) => {
    if (!params.data.specifications) return "";
    try {
      const specs = JSON.parse(params.data.specifications);
      return specs[key] || "";
    } catch (e) {
      return "";
    }
  };

  const columnDefs = [
    {
      headerName: "#",
      width: 60,
      minWidth: 60,
      maxWidth: 60,
      valueGetter: (params) => params.node.rowIndex + 1,
      pinned: 'left',
      lockPosition: true,
      suppressMenu: true,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: '#6c757d', backgroundColor: '#f8f9fa' }
    },
    {
      headerName: "Asset Details",
      field: "asset_name",
      minWidth: 220,
      cellRenderer: (params) => (
        <div style={{ lineHeight: '1.2', padding: '5px 0' }}>
          <div style={{ fontWeight: '600', color: '#2c3e50' }}>{params.value}</div>
          <div style={{ fontSize: '0.85em', color: '#7f8c8d' }}>
            {getSpecValue(params, 'manufacturer')} {getSpecValue(params, 'model')} {getSpecValue(params, 'device_type')}
          </div>
        </div>
      )
    },
    {
      headerName: "Serial / Tag",
      field: "serial_number",
      width: 150,
      cellRenderer: params => (
        <div className="d-flex flex-column">
          <span style={{ fontFamily: 'monospace', background: '#f8f9fa', padding: '2px 6px', borderRadius: '4px', border: '1px solid #e9ecef', fontSize: '0.85em' }}>
            {params.value || 'N/A'}
          </span>
          {params.data.tag_number && (
            <small className="text-muted mt-1" style={{ fontSize: '0.7em' }}>Tag: {params.data.tag_number}</small>
          )}
        </div>
      )
    },
    {
      headerName: "Custodian",
      field: "assigned_to",
      minWidth: 200,
      cellRenderer: params => (
        <div style={{ lineHeight: '1.2' }}>
          <div>{params.value || <span className="text-muted font-italic">Unassigned</span>}</div>
          <div className="small text-muted">
            {getSpecValue(params, 'location') || getSpecValue(params, 'office')}
          </div>
        </div>
      )
    },
    {
      headerName: "Specs",
      minWidth: 150,
      valueGetter: (params) => {
        try {
          const specs = JSON.parse(params.data.specifications);
          const cpu = specs['cpu'];
          const ram = specs['ram'];
          const storage = specs['storage_size'];
          const parts = [cpu, ram, storage].filter(Boolean);
          if (parts.length > 0) return parts.join(" • ");
          return "";
        } catch (e) {
          return params.data.specifications || "";
        }
      },
      tooltipField: "specifications"
    },
    {
      headerName: "Purchased",
      valueGetter: (params) => getSpecValue(params, 'purchase_year'),
      width: 100,
      suppressMenu: true,
    },
    {
      headerName: "Status",
      field: "status",
      width: 110,
      cellRenderer: (params) => {
        const status = parseInt(params.value);
        let color = "secondary";
        let label = status;

        if (status === 10001) {
          color = "success";
          label = "Active";
        } else if (status === 10002) {
          color = "danger";
          label = "Inactive";
        }

        return (
          <Badge color={color} pill className="px-2 color-white">
            {label}
          </Badge>
        )
      }
    },
    {
      headerName: "Actions",
      field: "id",
      width: 160, // Increased width to accommodate status button
      pinned: 'right',
      sortable: false,
      filter: false,
      cellRenderer: (params) => (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Button
            color="primary"
            size="sm"
            className="btn-icon rounded-circle mx-1 border-0 shadow-sm d-flex align-items-center justify-content-center"
            style={{ width: 30, height: 30, padding: 0 }}
            title="View History"
            onClick={() => handleView(params.data)}
          >
            <FaEye size={14} className="text-white" />
          </Button>
          <Button
            color="warning"
            size="sm"
            className="btn-icon rounded-circle mx-1 border-0 shadow-sm d-flex align-items-center justify-content-center"
            style={{ width: 30, height: 30, padding: 0 }}
            title="Issue Asset"
            onClick={() => handleIssueClick(params.data)}
          >
            <FaUserPlus size={14} className="text-white" />
          </Button>
          <Button
            color="info"
            size="sm"
            className="btn-icon rounded-circle mx-1 border-0 shadow-sm d-flex align-items-center justify-content-center"
            style={{ width: 30, height: 30, padding: 0 }}
            title="Edit"
            onClick={() => handleEdit(params.data)}
          >
            <FaEdit size={14} className="text-white" />
          </Button>
          <Button
            color="danger"
            size="sm"
            className="btn-icon rounded-circle mx-1 border-0 shadow-sm d-flex align-items-center justify-content-center"
            style={{ width: 30, height: 30, padding: 0 }}
            title="Delete"
            onClick={() => handleDeleteClick(params.data)}
          >
            <FaTrash size={14} className="text-white" />
          </Button>
        </div>
      )
    }
  ];

  const formatSpecs = (specString) => {
    try {
      const specs = JSON.parse(specString);
      return Object.entries(specs).map(([key, value]) => (
        <div key={key} className="d-flex justify-content-between border-bottom py-1 small">
          <span className="text-muted text-capitalize">{key.replace('_', ' ')}:</span>
          <span className="font-weight-bold text-dark">{value}</span>
        </div>
      ));
    } catch (e) {
      return <p className="text-muted small">{specString}</p>;
    }
  };

  return (
    <div className="p-4 animated fadeIn bg-white min-vh-100">
      <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
        <div>
          <h3 className="mb-0 font-weight-bold text-dark"> Asset Registry</h3>
          <p className="text-muted mb-0 small">Manage assets across the organization</p>
        </div>
        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
          <input
            type="file"
            accept=".xlsx, .xls"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
          <Button color="info" className="shadow-sm text-white d-flex align-items-center" onClick={() => fileInputRef.current.click()}>
            <FaFileUpload className="mr-2" /> Import Assets
          </Button>
          <Button color="success" className="shadow-sm d-flex align-items-center" onClick={toggleModal}>
            <FaPlus className="mr-2" /> Create Asset
          </Button>
        </div>
      </div>

      <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '8px' }}>
        <CardBody className="p-3">
          <Row form className="align-items-end">
            <Col md={3} className="mb-3 mb-md-0">
              <label className="font-weight-bold small text-uppercase text-muted mb-1" style={{ fontSize: '0.75rem' }}>Asset Category</label>
              <Input
                type="select"
                className="form-control shadow-sm border-light bg-white"
                onChange={(e) => fetch_data(e.target.value)}
                value={selectedCategory}
                style={{ height: '38px', fontSize: '0.9rem' }}
              >
                <option value="">All Categories</option>
                {category_list?.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.category_name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={5} className="mb-3 mb-md-0">
              <div className="position-relative">
                <FaSearch className="position-absolute text-muted" style={{ top: '50%', left: '15px', transform: 'translateY(-50%)', zIndex: 5 }} />
                <Input
                  type="text"
                  placeholder="Search assets..."
                  className="form-control border-0 bg-light rounded-pill"
                  value={quickFilterText}
                  onChange={onFilterTextChange}
                  style={{ height: 38, paddingLeft: '40px' }}
                />
              </div>
            </Col>
            <Col md={4} className="text-right pb-1">
              <span className="text-muted small mr-3">
                Showing <b>{rowData.length}</b> records
              </span>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="ag-theme-alpine w-100" style={{ height: 650 }}>
        <AgGridReact
          ref={gridRef}
          onGridReady={onGridReady}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          pagination={true}
          paginationPageSize={15}
          rowSelection="multiple"
          rowHeight={65}
          headerHeight={48}
          suppressCellSelection={true}
          overlayLoadingTemplate={
            '<div class="text-center p-4"><div class="spinner-border text-primary" role="status"></div><div class="mt-2 text-muted">Loading assets...</div></div>'
          }
          overlayNoRowsTemplate={
            '<div class="text-center p-5 text-muted"><h5 class="mb-3">No assets found</h5><p>Please select a category or adjust your search filters.</p></div>'
          }
        />
      </div>

      {/* Create/Edit Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{isEditing ? "Update Asset" : "Create New Asset"}</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="asset_name">Asset Name <span className="text-danger">*</span></Label>
                  <Input type="text" name="asset_name" id="asset_name" value={formData.asset_name} onChange={handleInputChange} placeholder="e.g. HP Laptop" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="category_id">Category <span className="text-danger">*</span></Label>
                  <Input type="select" name="category_id" id="category_id" value={formData.category_id} onChange={handleInputChange}>
                    <option value="">Select Category</option>
                    {category_list?.map((c) => (
                      <option key={c.id} value={c.id}>{c.category_name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="serial_number">Serial Number</Label>
                  <Input type="text" name="serial_number" id="serial_number" value={formData.serial_number} onChange={handleInputChange} />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="tag_number">Tag Number</Label>
                  <Input type="text" name="tag_number" id="tag_number" value={formData.tag_number} onChange={handleInputChange} />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="procurement_reference">Procurement Ref</Label>
                  <Input type="text" name="procurement_reference" id="procurement_reference" value={formData.procurement_reference} onChange={handleInputChange} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="office_id">Office</Label>
                  <Input type="select" name="office_id" id="office_id" value={formData.office_id} onChange={handleInputChange}>
                    <option value="">Select Office...</option>
                    {office_list?.map((office) => (
                      <option key={office.id} value={office.id}>
                        {office.office_name || office.name || "Office " + office.id}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="assigned_to">Assigned To (Email)</Label>
                  <Input type="email" name="assigned_to" id="assigned_to" value={formData.assigned_to} onChange={handleInputChange} />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="specifications">Specifications</Label>
              <Input type="textarea" name="specifications" id="specifications" value={formData.specifications} onChange={handleInputChange} rows={3} placeholder='JSON or text e.g. "Laser printer, A4, Network capable"' />
            </FormGroup>
            <FormGroup>
              <Label for="remarks">Remarks</Label>
              <Input type="textarea" name="remarks" id="remarks" value={formData.remarks} onChange={handleInputChange} rows={2} />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>Cancel</Button>
          <Button color="primary" onClick={handleSave}>
            {isEditing ? "Update Asset" : "Submit Asset"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} size="md" centered>
        <ModalHeader toggle={toggleDeleteModal} className="text-danger">Confirm Deletion</ModalHeader>
        <ModalBody>
          <div className="text-center p-3">
            <div className="display-4 text-danger mb-3">
              <FaTrash />
            </div>
            <p className="lead">Are you sure you want to delete this asset?</p>
            <p className="text-muted small">This action might be irreversible. Please confirm.</p>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button color="secondary" onClick={toggleDeleteModal} outline>Cancel</Button>
          <Button color="danger" onClick={confirmDelete}>Delete Asset</Button>
        </ModalFooter>
      </Modal>

      {/* Batch Import Status Modal */}
      <Modal isOpen={batchModalOpen} toggle={() => !isBatchProcessing && setBatchModalOpen(false)} size="lg">
        <ModalHeader toggle={() => !isBatchProcessing && setBatchModalOpen(false)}>Importing Assets...</ModalHeader>
        <ModalBody>
          <div className="text-center mb-3">
            <h5 className="mb-2">{isBatchProcessing ? "Processing..." : "Import Completed"}</h5>
            <Progress value={batchProgress} color={batchProgress === 100 ? "success" : "primary"} striped={isBatchProcessing} animated={isBatchProcessing}>
              {batchProgress}%
            </Progress>
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto', background: '#f8f9fa', padding: '10px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
            {batchLogs.length === 0 && <p className="text-muted text-center small">Waiting to start...</p>}
            {batchLogs.map((log, idx) => (
              <div key={idx} className="small mb-1" style={{ fontFamily: 'monospace' }}>{log}</div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setBatchModalOpen(false)} disabled={isBatchProcessing}>Close</Button>
        </ModalFooter>
      </Modal>

      {/* Issue Asset Modal */}
      <Modal isOpen={issueModalOpen} toggle={() => setIssueModalOpen(false)} size="md" centered>
        <ModalHeader toggle={() => setIssueModalOpen(false)}>
          Issue Asset: <span className="text-primary">{issuingAsset?.asset_name}</span>
        </ModalHeader>
        <ModalBody>
          {issuingAsset?.assigned_to && (
            <div className="alert alert-warning small mb-3">
              <FaUser className="mr-1" /> Currently assigned to: <strong>{issuingAsset.assigned_to}</strong>
              <div className="mt-1">This action will return the asset from the current holder and issue it to the new user.</div>
            </div>
          )}
          <FormGroup>
            <Label for="assigned_to" className="font-weight-bold">Assign To (Email) <span className="text-danger">*</span></Label>
            <Input
              type="email"
              name="assigned_to"
              id="issue_assigned_to"
              placeholder="Enter employee email..."
              value={issueFormData.assigned_to}
              onChange={handleIssueInputChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="issue_remarks" className="font-weight-bold">Issue Remarks</Label>
            <Input
              type="textarea"
              name="issue_remarks"
              id="issue_remarks"
              rows="3"
              placeholder="Condition of asset, specific instructions, etc."
              value={issueFormData.issue_remarks}
              onChange={handleIssueInputChange}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIssueModalOpen(false)}>Cancel</Button>
          <Button color="primary" onClick={handleIssueSubmit}>Confirm Issue</Button>
        </ModalFooter>
      </Modal>

      {/* View Asset Details & History Modal */}
      <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)} size="xl" centered>
        <ModalHeader toggle={() => setViewModalOpen(false)} className="bg-light">
          <div className="d-flex align-items-center">
            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3" style={{ width: 40, height: 40 }}>
              <FaDesktop />
            </div>
            <div>
              <h5 className="mb-0 text-dark">{viewAsset?.asset_name}</h5>
              <small className="text-muted">Serial: {viewAsset?.serial_number} | Tag: {viewAsset?.tag_number || 'N/A'}</small>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="p-0">
          <Row className="m-0">
            <Col lg={12} md={12} className="bg-light border-right p-4">
              <h6 className="font-weight-bold text-uppercase text-secondary mb-3 small">Asset Specifications</h6>
              <div className="bg-white p-3 rounded shadow-sm mb-4">
                {viewAsset && formatSpecs(viewAsset.specifications)}
              </div>

              <h6 className="font-weight-bold text-uppercase text-secondary mb-3 small">Current Status</h6>
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="mb-2 text-primary font-weight-bold">
                  {viewAsset?.status === 10001 ? <><FaCheckCircle className="mr-2" /> Active</> : "Inactive"}
                </div>
                <div className="small text-muted mb-1">Assigned To:</div>
                <div className="font-weight-bold text-dark mb-2">{viewAsset?.assigned_to || "Unassigned"}</div>
                <div className="small text-muted mb-1">Remarks:</div>
                <div className="small font-italic">{viewAsset?.remarks || "No remarks"}</div>
              </div>
            </Col>

            <Col lg={12} md={12} className="p-4" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
              <h6 className="font-weight-bold text-uppercase text-secondary mb-4 small d-flex align-items-center">
                <FaHistory className="mr-2" /> Custody History
              </h6>

              <div className="timeline pl-2" style={{ borderLeft: '2px solid #e9ecef', marginLeft: '10px' }}>
                {viewAsset?.asset_holders?.length > 0 ? (
                  viewAsset.asset_holders.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((holder, index) => (
                    <div key={index} className="position-relative pl-4 pb-4">
                      {/* Timeline dot */}
                      <div className={`position-absolute rounded-circle ${holder.status === 10001 ? 'bg-success' : 'bg-secondary'}`}
                        style={{ width: 12, height: 12, left: -7, top: 4, border: '2px solid white', boxShadow: '0 0 0 1px #dee2e6' }}></div>

                      <div className="card border-0 shadow-sm">
                        <div className="card-body p-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="font-weight-bold mb-0 text-dark" style={{ fontSize: '0.9rem' }}>
                              {holder.email}
                            </h6>
                            <span className="badge badge-light text-muted">
                              {holder.status === 10001 ? 'Current' : 'Returned'}
                            </span>
                          </div>

                          <div className="small text-muted mb-2 d-flex align-items-center">
                            <FaCalendarAlt className="mr-2 text-info" />
                            {new Date(holder.created_at).toLocaleString()}
                          </div>

                          {holder.issue_remarks && (
                            <div className="small bg-light p-2 rounded mb-2 text-dark">
                              <strong>Issued:</strong> {holder.issue_remarks}
                            </div>
                          )}
                          {holder.return_remarks && (
                            <div className="small bg-light p-2 rounded mb-2 text-dark">
                              <strong>Returned:</strong> {holder.return_remarks}
                            </div>
                          )}

                          {holder.created_by && (
                            <div className="text-right small text-muted mt-2 border-top pt-2">
                              Processed by: <span className="text-dark font-weight-500">{holder.created_by.name}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="pl-4 text-muted small font-italic">No history records found.</div>
                )}
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button color="secondary" onClick={() => setViewModalOpen(false)}>Close View</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AssetList;
